import { useField } from 'formik';
import { DatePicker as DatePickerMantine } from '@mantine/dates';

// @ts-expect-error dumb
export const DatePicker = ({ label, ...props }) => {
  // @ts-expect-error dumb
  const [field, meta, helpers] = useField(props);

  const { value } = meta;
  const { setValue } = helpers;

  return (
    <DatePickerMantine
      label={label}
      value={value}
      onChange={(e) => setValue(e)}
      error={meta.touched && meta.error}
      {...props}
    />
  );
};
